export const environment = {
  production: false,
  hmr: false,
  debug: true,
  client: 'Nissan-US',
  hostName: 'insight-staging.nissanactivebuyerreferral.com',
  environmentName: 'staging',
  appName: 'Nissan-US Analytics',
  ssoPassword: 'ShiftDigital#1',
  applicationInsights: {
    instrumentationKey: '7693eecf-408b-4d5d-a23e-d5adf8c3fbad'
  },
  defaultLocale: 'en',
  availableLocales: ['en'],
  timeZone: 'Eastern Standard Time',
  showLocaleSelector: 'false',
  numberOfMonthsToShowDefault: 13,
  numberOfQuartersToShowDefault: 8,
  defaultOrgLevelTypeIds: [1],
  closeRateLookbackMonths: 3,
  defaultChartColors: ['#8c8c8c', '#ed1c24', '#A6A6A6', '#D9D9D9', '#CCCCCC'],
  baseApiUri: 'https://nissanus-analytics-api-staging.azurewebsites.net/api',
  authUri: 'https://nissanus-analytics-api-staging.azurewebsites.net/token',
  baseV5ApiUri: 'https://nissanus-analytics-apiv5-staging.azurewebsites.net/api',
  retailerToolsBaseUri: 'https://nissanus-retailertools-web-staging.azurewebsites.net',
  retailerToolsIncludeAuth: true,
  mysteryShopBaseUri: '',
  favIconPath: '/assets/icons/clients/nissan-us/favicon.ico',
  loginRedirectUrl: '',
  logoutRedirectUrl: '',
  sidebarDefaultOpen: false,
  useV5WebsiteOverview: false,
    v5Reports: ['ChatOverview', 'LeadsOverview', 'SalesOverview', 'LeadTransactionsOverview', 'WebsiteOverview']
};
